import { render, staticRenderFns } from "./AlarmRecords.vue?vue&type=template&id=5b083651&scoped=true&"
import script from "./AlarmRecords.vue?vue&type=script&lang=js&"
export * from "./AlarmRecords.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRecords.vue?vue&type=style&index=0&id=5b083651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b083651",
  null
  
)

export default component.exports